import { Component, OnInit }    from '@angular/core';
import { Router } from '@angular/router';

import { JourneysService }      from './journeys.service';
import { EditionService }       from './../../shared/services/edition.service';
import { EditionListService }   from './../../editions/edition.service';
import { PermissionsService }   from './../../shared/services/permissions.service';

import { Journey }              from './../../models/journey/journey';
import { JourneyDetail }        from './../../models/journey/journey-detail';


@Component({
  selector: 'app-journeys',
  templateUrl: './journeys.component.html',
  styleUrls: ['./journeys.component.less'],
  providers: [JourneysService]
})

export class JourneysComponent implements OnInit {
  journeys: Journey[];
  loaded: boolean;
  showJourneyAdd: boolean;
  showJourneyClone: boolean;
  savingJourney: boolean;
  canSeeCloning: boolean;
  canOnlyClone: boolean;
  cloneAlerts: string[];
  canListSubscriptions: boolean;
  public minimalStateObj: {categoryType: string; mapping: string};

  constructor(
    private journeysService: JourneysService,
    private editionService: EditionService,
    private editionListService: EditionListService,
    private permissionsService: PermissionsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.permissionsService.retrievePermissions().subscribe(permissions => {
      this.canSeeCloning = permissions.cloneJourney;
      this.canListSubscriptions = permissions.listSubscriptions;
    });
    this.canOnlyClone = this.permissionsService.simplifiedJourneyManagement;
    this.minimalStateObj = {categoryType: 'edition', mapping: 'journey'};
    this.journeysService
        .getJourneys()
        .subscribe((journeys) => {
          this.journeys = journeys;
          this.loaded = true;
        });
  }

  private routeToJourney(id: number): void {
    this.router.navigate(["dashboard", "journeys", "journey", id]);
  }

  public async submitNewJourney(journey: JourneyDetail): Promise<void> {
    this.savingJourney = true;
    this.journeysService
      .submitNewJourney(journey)
      .subscribe(async (newJourney) => {
        let updated = await this.editionListService.refreshCurrentEdition();
        this.showJourneyAdd = false;
        this.savingJourney = false;
        this.routeToJourney(newJourney.id);
      });
  }

  public async cloneJourney(journeyId: number): Promise<void> {
    this.savingJourney = true;
    let override = !!(this.cloneAlerts && this.cloneAlerts.length);
    this.journeysService
      .cloneJourney(journeyId, this.editionListService.getEdition().id, override)
      .subscribe(async(resp) => {
        let updated = await this.editionListService.refreshCurrentEdition()
        if (resp.id) {
          this.routeToJourney(resp.id);
          this.showJourneyClone = false;
          this.cloneAlerts = [];
        } else {
          // Pass alerts to Clone Journey component for user review
          this.cloneAlerts = resp.alerts;
        }
        this.savingJourney = false;
      });
  }

  private menuItemSelected(item: string, journeyId: number): void {
    switch (item) {
      case 'open':
        let path = `/programs?journey=${journeyId}`;
        this.editionService.jumpToLearning(path);
      case 'add':
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journeys.component.ts